<template src='./project-phases.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import HighlightButton from '@/components/misc/HighlightButton.vue'
import { EventBus } from '@/router/bus'
import { hasAdminClaim, hasMeiClaim, hasMinisterClaim, authorizedOrganizationId, hasProjectManageClaim, hasFormConfirmationResolveClaim, hasProjectSendMinistryClaim, hasFormApprovalResolveClaim, hasProjectEvaluateClaim, hasProjectIdeaVerificationManage, hasProjectIdeaApproveManage, hasMeiApprovalCommentSendClaim, hasSendRequestChangeForm, hasFormImportantManage } from '@/router/auth'
import PhaseForms from './forms/PhaseForms'
import PhaseActivities from './activities/PhaseActivities'
import SuccessKeyIndicators from './success-key-indicators/SuccessKeyIndicators'

export default {
  components: {
    ContextPage,
    HighlightButton,
    'phase-forms': PhaseForms,
    'phase-activities': PhaseActivities,
    'success-key-indicators': SuccessKeyIndicators
  },
  props: ['clickedPhase', 'isMeiCommentPopulated', 'isMfinCommentPopulated'],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      selectedPhase: {},
      phases: [],
      project: {},
      pageLoader: false,
      showActionPromptOptions: false,
      showThirdActionOption: false,
      showFourthActionOption: false,
      showFifthActionOption: false,
      showNoMfinCommented: false,
      showDateControl: false,
      showPostponedDateControl: false,
      firstActionText: this.$t('form.yes'),
      secondActionText: this.$t('form.no'),
      thirdActionText: this.$t('form.stopped'),
      formActionText: '',
      dateControlText: this.$t('form.date'),
      phaseStatus: {
        ENTRY: 1,
        WAITINGCONFIRMATION: 2,
        WAITINGAPPROVAL: 3,
        APPROVED: 4,
        RATIONALIZATIONPROPOSAL: 5,
        WAITINGCOMMISSIONDECISION: 6,
        CORRECTION: 7,
        POSTPONED: 8,
        STOPPED: 9,
        ACCEPTEDRATIONALIZATION: 10,
        CANCELED: 11,
        WAITINGQUARTERCONFIRMATION: 12,
        WAITINGQUARTERAPPROVAL: 13,
        IDEA: 14,
        PROJECTIDENTIFICATION: 15,
        PREPAREDNESS: 16,
        IMPORTANT: 17,
        STILLNESS: 18,
        VERIFICATIONSEND: 19,
        VERIFICATION: 20,
        MINISTERAPPROVALSEND: 21,
        MINISTERAPPROVAL: 22,
        MEIAPPROVALCOMMENTSEND: 23,
        MEIAPPROVALCOMMENT: 24,
        SENDREQUESTCHANGEFORM: 25,
        CORRECTIONREQUEST: 26,
        APPROVEDCORRECTIONREQUEST: 27,
        CORRECTIONWAITINGLIST: 28,
        CORRECTIONAMENDMENT: 29,
        RATIONALIZATIONPOSTPONED: 30,
        RATIONALIZATIONSHUTDOWN: 31,
        CORRECTIOAMENDMENTAPPROVAL: 33,
        CORRECTIOAMENDMENTCONFIRMATION: 34
      },
      projectStatus: {
        PENDING: 0,
        FINISHED: 1
      },
      projectAction: {
        FIRST: 1,
        SECOND: 2,
        THIRD: 3,
        FOURTH: 4,
        FIFTH: 5,
        SIXTH: 6
      },
      formStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      },
      projectPhases: {
        IDEA: 0,
        PROJECTIDENTIFICATION: 1,
        PREPAREDNESS: 2,
        IMPORTANT: 3,
        PLAN: 4,
        REPORTING: 5,
        RATIONALIZATION: 13,
        CONCLUSION: 7,
        EFFECTS: 8,
        PREIMPLEMENTATION: 9,
        IDENTIFICATION: 10,
        CORRECTION: 11,
        CORRECTIONREPORTING: 12
      },
      dialog: false,
      successKeyIndicatorDialog: false,
      status: {
        action: 1,
        comment: '',
        date: '',
        postponedDate: ''
      },
      tab: null,
      phaseStatusesWithoutPrompt: [1]
    }
  },
  computed: {
    isAdmin () {
      return hasAdminClaim()
    },
    isMei () {
      return hasMeiClaim()
    },
    isMinister () {
      return hasMinisterClaim()
    },
    canSendToMinistry () {
      return hasProjectSendMinistryClaim() && !hasAdminClaim()
    },
    canMeiApprovalCommentSendClaim () {
      return hasMeiApprovalCommentSendClaim() && !hasAdminClaim()
    },
    organizationId () {
      return authorizedOrganizationId()
    },
    canApproveProject () {
      return hasProjectIdeaApproveManage() && this.project && this.project.status === this.projectStatus.PENDING
    },
    canSendRequestChangeForm () {
      return hasSendRequestChangeForm()
    },
    canVerifyProject () {
      return hasProjectIdeaVerificationManage() && this.project && this.project.status === this.projectStatus.PENDING
    },
    canManageProject () {
      return hasProjectManageClaim() && this.project && this.project.status === this.projectStatus.PENDING
    },
    canResolveFormConfirmation () {
      return hasFormConfirmationResolveClaim() && this.project && this.project.status === this.projectStatus.PENDING
    },
    canResolveFormApproval () {
      return hasFormApprovalResolveClaim() && this.project && this.project.status === this.projectStatus.PENDING
    },
    canEvaluateProject () {
      return hasProjectEvaluateClaim() && this.project && this.project.status === this.projectStatus.PENDING
    },
    canManageImportant () {
      return hasFormImportantManage()
    },
    displayActionButton () {
      if (this.project.phase === this.projectPhases.PROJECTIDENTIFICATION && this.isMinister) {
        return false
      }
      if (!this.project || !this.selectedPhase) {
        return false
      }
      if (this.project.phase !== this.selectedPhase.phase) {
        return false
      }
      if (this.selectedPhase.status === this.phaseStatus.APPROVED || this.selectedPhase.status === this.phaseStatus.ACCEPTEDRATIONALIZATION || this.selectedPhase.status === this.phaseStatus.CORRECTION) {
        return false
      }
      if (this.project.status !== this.projectStatus.PENDING) {
        return false
      }
      if (this.selectedPhase.forms && !this.selectedPhase.forms.some(form => form.status === this.formStatus.LOCKED)) {
        return false
      }
      if (this.project.important && this.project.phase === this.projectPhases.IMPORTANT && this.project.phaseStatus === this.phaseStatus.WAITINGAPPROVAL) {
        return false
      }
      // if (this.canApproveProject && this.project.phaseStatus === this.phaseStatus.MINISTERAPPROVAL && hasProjectIdeaMinisterApprovalClaim()) {
      //   return true
      // }
      if (this.canApproveProject && (this.project.phaseStatus === this.phaseStatus.WAITINGAPPROVAL)) {
        return true
      }
      if (this.canManageProject && (this.project.organizationId === this.organizationId || (this.canManageImportant && this.project.phase === this.projectPhases.IMPORTANT && !this.isAdmin)) && (this.project.phaseStatus === this.phaseStatus.ENTRY || this.project.phaseStatus === this.phaseStatus.CORRECTIONAMENDMENT || this.project.phaseStatus === this.phaseStatus.CORRECTIOAMENDMENTAPPROVAL)) {
        return true
      }
      if (this.canResolveFormConfirmation && (this.project.organizationId === this.organizationId || (this.canManageImportant && this.project.phase === this.projectPhases.IMPORTANT && !this.isAdmin)) && (this.selectedPhase.status === this.phaseStatus.WAITINGCONFIRMATION || this.selectedPhase.status === this.phaseStatus.WAITINGQUARTERCONFIRMATION)) {
        return true
      }
      if (this.canResolveFormApproval && (this.selectedPhase.status === this.phaseStatus.WAITINGAPPROVAL || this.selectedPhase.status === this.phaseStatus.WAITINGQUARTERAPPROVAL || this.selectedPhase.status === this.phaseStatus.CORRECTIOAMENDMENTCONFIRMATION)) {
        return true
      }
      return false
    },
    displayRationalizationProposalButton () {
      return (this.isAdmin && this.project.phase === this.projectPhases.REPORTING &&
              this.selectedPhase.phase === this.projectPhases.REPORTING &&
              (this.selectedPhase.status === this.phaseStatus.ENTRY ||
              this.selectedPhase.status === this.phaseStatus.REPORTING ||
              this.selectedPhase.status === this.phaseStatus.WAITINGCONFIRMATION ||
              this.selectedPhase.status === this.phaseStatus.WAITINGAPPROVAL ||
              this.selectedPhase.status === this.phaseStatus.WAITINGQUARTERCONFIRMATION ||
              this.selectedPhase.status === this.phaseStatus.WAITINGQUARTERAPPROVAL
              ) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => x.status === this.formStatus.APPROVED).length >= this.project.sendingToCommissionFormsLimit &&
              0 === 1)
    },
    displayRationalizationActionProposalButton () {
      return (this.isAdmin && this.project.phaseStatus === this.phaseStatus.RATIONALIZATIONPOSTPONED &&
        this.selectedPhase.forms
      )
    },
    displayPlanCorrectionButton () {
      return (this.isAdmin &&
              this.project.phase === this.projectPhases.REPORTING &&
              this.selectedPhase.phase === this.projectPhases.REPORTING &&
              (this.selectedPhase.status === this.phaseStatus.ENTRY || this.selectedPhase.status === this.phaseStatus.WAITINGCONFIRMATION ||
              this.selectedPhase.status === this.phaseStatus.WAITINGAPPROVAL ||
              this.selectedPhase.status === this.phaseStatus.WAITINGQUARTERCONFIRMATION ||
              this.selectedPhase.status === this.phaseStatus.WAITINGQUARTERAPPROVAL) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => x.status === this.formStatus.APPROVED).length >= this.project.planCorrectionFormsLimit &&
              0 === 1
              // Privremeno iskljuceno jer se promenio flow
      )
    },
    displayCommissionDecisionButton () {
      return (this.isAdmin &&
             (this.project.phase === this.projectPhases.RATIONALIZATION || this.project.phase === this.projectPhases.REPORTING) &&
             (this.selectedPhase.phase === this.projectPhases.RATIONALIZATION || this.project.phase === this.projectPhases.REPORTING) &&
             this.selectedPhase.status === this.phaseStatus.WAITINGCOMMISSIONDECISION)
    },
    displaySuccessKeyIndicatorButton () {
      return (this.isAdmin &&
              (this.selectedPhase.phase === this.projectPhases.REPORTING || this.selectedPhase.phase === this.projectPhases.CORRECTIONREPORTING) &&
              this.selectedPhase.forms
              // &&         this.selectedPhase.forms.filter(x => x.status === this.formStatus.APPROVED).length >= 1
      )
    },
    displayCancelPreImplementationButton () {
      return (this.canManageProject &&
             this.project.organizationId === this.organizationId &&
             this.project.phase === this.projectPhases.PREIMPLEMENTATION &&
             this.selectedPhase.phase === this.projectPhases.PREIMPLEMENTATION &&
             (this.selectedPhase.status === this.phaseStatus.ENTRY ||
             this.selectedPhase.status === this.phaseStatus.WAITINGCONFIRMATION ||
             this.selectedPhase.status === this.phaseStatus.WAITINGAPPROVAL))
    },
    displayUpdateApproveImportantButton () {
      return this.isAdmin && this.project.phase === this.projectPhases.IMPORTANT &&
              this.project.phaseStatus === this.projectPhases.IMPORTANT &&
              this.selectedPhase.phase === this.projectPhases.IMPORTANT &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    },
    displayIdeaButton () {
      return this.isAdmin && this.project.phase === this.projectPhases.IDEA &&
              this.selectedPhase.phase === this.projectPhases.IDEA &&
              this.selectedPhase.status === this.phaseStatus.APPROVED &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    },
    displayCorrectionButton () {
      return this.isAdmin && this.project.phase === this.projectPhases.CORRECTION &&
              this.selectedPhase.phase === this.projectPhases.CORRECTION &&
              this.selectedPhase.status === this.phaseStatus.APPROVED &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    },
    displayAdminReturnButton () {
      return this.isAdmin &&
          (
            (this.project.phase === this.projectPhases.IDEA && this.selectedPhase.phase === this.projectPhases.IDEA) ||
            (this.project.phase === this.projectPhases.PROJECTIDENTIFICATION && this.selectedPhase.phase === this.projectPhases.PROJECTIDENTIFICATION) ||
            (this.project.phase === this.projectPhases.PREPAREDNESS && this.selectedPhase.phase === this.projectPhases.PREPAREDNESS)
          ) &&
              (this.selectedPhase.status === this.phaseStatus.APPROVED || this.selectedPhase.status === this.phaseStatus.SENDREQUESTCHANGEFORM) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    },
    displayProjectIdentificationButton () {
      return this.isAdmin && this.project.phase === this.projectPhases.PROJECTIDENTIFICATION &&
              this.selectedPhase.phase === this.projectPhases.PROJECTIDENTIFICATION &&
              this.selectedPhase.status === this.phaseStatus.APPROVED &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    },
    displayPreparednessButton () {
      return this.isAdmin && this.project.phase === this.projectPhases.PREPAREDNESS &&
              this.selectedPhase.phase === this.projectPhases.PREPAREDNESS &&
              this.selectedPhase.status === this.phaseStatus.APPROVED &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    },
    // displayVerificationSendButton () {
    //   return this.canManageProject && this.project.phase === this.projectPhases.IDEA &&
    //           this.selectedPhase.phase === this.projectPhases.IDEA &&
    //           this.selectedPhase.status === this.phaseStatus.VERIFICATIONSEND &&
    //           this.selectedPhase.forms &&
    //           this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    // },
    displayMinisterApprovalButton () {
      return this.isMinister && this.project.phase === this.projectPhases.IDEA &&
              this.selectedPhase.phase === this.projectPhases.IDEA &&
              this.selectedPhase.status === this.phaseStatus.MINISTERAPPROVAL
    },
    displayMinisterApprovalSendButton () {
      return this.canSendToMinistry && this.project.phase === this.projectPhases.IDEA &&
              this.selectedPhase.phase === this.projectPhases.IDEA &&
              this.selectedPhase.status === this.phaseStatus.MINISTERAPPROVALSEND
    },
    displayMeiApprovalCommentSendButton () {
      return this.canMeiApprovalCommentSendClaim && this.project.phase === this.projectPhases.IDEA &&
              this.selectedPhase.phase === this.projectPhases.IDEA &&
              this.selectedPhase.status === this.phaseStatus.MEIAPPROVALCOMMENTSEND &&
              this.project.foreignFunds
    },
    displayMeiApprovalCommentButton () {
      return this.isMei && this.project.phase === this.projectPhases.IDEA &&
             this.selectedPhase.phase === this.projectPhases.IDEA &&
             this.selectedPhase.status === this.phaseStatus.MEIAPPROVALCOMMENT &&
             this.project.foreignFunds && this.isMeiCommentPopulated
    },
    displayIdeaCommissionDecisionButton () {
      return this.isAdmin && (this.project.phase === this.projectPhases.IDEA || this.project.phaseStatus === this.phaseStatus.STILLNESS) &&
              this.selectedPhase.phase === this.projectPhases.IDEA &&
              (this.selectedPhase.status === this.phaseStatus.WAITINGCOMMISSIONDECISION || this.selectedPhase.status === this.phaseStatus.STILLNESS) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => x.status === this.formStatus.APPROVED).length >= 1
    },
    displayIdeaRequestReturnFormButton () {
      return this.canSendRequestChangeForm &&
          (
            (this.project.phase === this.projectPhases.IDEA && this.selectedPhase.phase === this.projectPhases.IDEA) ||
            (this.project.phase === this.projectPhases.PROJECTIDENTIFICATION && this.selectedPhase.phase === this.projectPhases.PROJECTIDENTIFICATION) ||
            (this.project.phase === this.projectPhases.PREPAREDNESS && this.selectedPhase.phase === this.projectPhases.PREPAREDNESS)
          ) &&
              (this.selectedPhase.status === this.phaseStatus.APPROVED) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => (x.status === this.formStatus.APPROVED || x.status === this.formStatus.LOCKED)).length >= 1
    },
    displayCorrectionSendButton () {
      return this.isAdmin && (this.project.phase === this.projectPhases.REPORTING && this.selectedPhase.phase === this.projectPhases.REPORTING)
    },
    displayProjectIdentificationDecisionButton () {
      return this.isAdmin && (this.project.phase === this.projectPhases.PROJECTIDENTIFICATION || this.project.phaseStatus === this.phaseStatus.STILLNESS) &&
              this.selectedPhase.phase === this.projectPhases.PROJECTIDENTIFICATION &&
              (this.selectedPhase.status === this.phaseStatus.WAITINGCOMMISSIONDECISION || this.selectedPhase.status === this.phaseStatus.STILLNESS) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => x.status === this.formStatus.APPROVED).length >= 1
    },
    displayPreparednessDecisionButton () {
      return this.isAdmin && (this.project.phase === this.projectPhases.PREPAREDNESS || this.project.phaseStatus === this.phaseStatus.STILLNESS) &&
              this.selectedPhase.phase === this.projectPhases.PREPAREDNESS &&
              (this.selectedPhase.status === this.phaseStatus.WAITINGCOMMISSIONDECISION || this.selectedPhase.status === this.phaseStatus.STILLNESS) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => x.status === this.formStatus.APPROVED).length >= 1
    },
    displayCorrectionDecisionButton () {
      return this.isAdmin && (this.project.phase === this.projectPhases.CORRECTION || this.project.phaseStatus === this.phaseStatus.CORRECTION) &&
              this.selectedPhase.phase === this.projectPhases.CORRECTION &&
              (this.selectedPhase.status === this.phaseStatus.WAITINGCOMMISSIONDECISION) &&
              this.selectedPhase.forms &&
              this.selectedPhase.forms.filter(x => x.status === this.formStatus.APPROVED).length >= 1
    },
    getColor () {
      return this.selectedPhase.status === this.phaseStatus.STOPPED || this.selectedPhase.status === this.phaseStatus.CANCELED ? 'var(--v-error-lighten3)' : this.project.phase === this.selectedPhase.phase ? 'var(--v-cards-base)' : 'var(--v-success-light-base)'
    },
    isLastFormInPhase () {
      return this.project.phase === this.selectedPhase.phase && this.selectedPhase.status === this.phaseStatus.ENTRY && this.project.phase === this.projectPhases.REPORTING && this.selectedPhase.formsLimit <= this.selectedPhase.forms.length
    },
    unSuccessPhaseStatus () {
      return this.selectedPhase.status === this.phaseStatus.STOPPED || this.selectedPhase.status === this.phaseStatus.CANCELED
    },
    isPreImplementationPhaseInEntryStatus () {
      return (this.canManageProject && this.project.organizationId === this.organizationId && this.project.phase === this.projectPhases.PREIMPLEMENTATION && this.selectedPhase.phase === this.projectPhases.PREIMPLEMENTATION && this.selectedPhase.status === this.phaseStatus.ENTRY)
    },
    isReportingPhaseInEntryStatus () {
      return (this.canManageProject && this.project.organizationId === this.organizationId && this.project.phase === this.projectPhases.REPORTING && this.selectedPhase.phase === this.projectPhases.REPORTING && this.selectedPhase.status === this.phaseStatus.ENTRY)
    }
  },
  created () {
    EventBus.$emit('reload-crumbs')
    this.setupPage()
  },
  mounted () {
    const routeTab = this.$route.path.split('/')[5]
    if (this.tab !== routeTab) {
      this.tab = routeTab
    }
  },
  watch: {
    selectedPhase (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.projectPhaseId = newVal.id
        // history.pushState({}, null, '/projects/' + this.projectCode + '/phases/' + Number(this.projectPhaseId) + '/' + this.tab)
        if (newVal.phase === this.projectPhases.REPORTING) {
          this.selectedPhase.forms = this.selectedPhase.forms.reverse()
        }
        EventBus.$emit('selectedPhase', newVal)
      }
    },
    clickedPhase (newVal, oldVal) {
      if (newVal !== oldVal) {
        const newPhase = this.phases.filter(t => t.id === newVal.id)
        if (newPhase[0]) {
          this.selectedPhase = newPhase[0]
        }
      }
    }
  },
  methods: {
    setupPage () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.projectPhasesGet.replace('{projectCode}', this.$route.params.projectCode))
        .then(
          response => {
            // this.logConsole(response)
            this.project = response.data.additionalInformation
            this.setPhase(response.data.payload, false)
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    openSuccessKeyIndicatorDialog () {
      this.successKeyIndicatorDialog = true
    },
    openInvokeActionDialog () {
      this.setDefaultActionsText()
      // this.showActionPromptOptions = (this.isPreImplementationPhaseInEntryStatus || (this.isLastFormInPhase && this.isReportingPhaseInEntryStatus)) || !this.phaseStatusesWithoutPrompt.includes(this.project.phaseStatus)
      this.showActionPromptOptions = !this.phaseStatusesWithoutPrompt.includes(this.project.phaseStatus)
      this.status.comment = ''
      if (this.project.phaseStatus === this.phaseStatus.WAITINGAPPROVAL) {
        this.secondActionText = this.$t('form.return')
      }
      if (this.isPreImplementationPhaseInEntryStatus) {
        this.showThirdActionOption = false
        this.status.action = this.projectAction.SECOND
      } else {
        this.status.action = this.projectAction.FIRST
      }
      this.dialog = true
    },
    openInvokeActionDialogReturn () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openInvokeActionSendFormForUpdate () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.SECOND
      this.dialog = true
    },
    openInvokeActionOpenCorrection () {
      this.setDefaultActionsText()
      this.formActionText = this.$t('projects.invokeCorrectionActionPrompt')
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.SIXTH
      this.dialog = true
    },
    invokeAction () {
      if (!this.commentValid()) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('projects.commentRequired'),
          errors: []
        })
        return
      }
      if (!this.dateValid()) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('projects.dateValid'),
          errors: []
        })
        return
      }
      this.pageLoader = true
      this.showLoader(true)
      // console.log(Vue.$apiConfig.invokeActionPut.replace('{projectCode}', this.$route.params.projectCode))
      // console.log('status: ' + this.status)
      this.$http.put(Vue.$apiConfig.invokeActionPut.replace('{projectCode}', this.$route.params.projectCode), this.status)
        .then(
          response => {
            this.project = response.data.payload
            this.setPhase(this.project.phases, true)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('projects.invokeActionSuccessful'),
              errors: []
            })
            EventBus.$emit('auto-phase', this.project.phases, this.project.phase, this.project.status)
            this.showLoader(false)
            this.pageLoader = false
            this.dialog = false
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
            this.pageLoader = false
            this.dialog = false
          }
        )
    },
    commentValid () {
      if (this.project.phase === this.projectPhases.PREIMPLEMENTATION && this.status.comment === '' && this.status.action === this.projectAction.THIRD) {
        return false
      }
      return true
    },
    dateValid () {
      if (this.status.date === '' && this.showDateControl &&
         (this.project.phase === this.projectPhases.IDEA || this.project.phase === this.projectPhases.PROJECTIDENTIFICATION || this.project.phase === this.projectPhases.PREPAREDNESS)
      ) {
        return false
      }
      return true
    },
    setPhase (phases, setLastPhase) {
      if (setLastPhase || !this.projectPhaseId) {
        this.projectPhaseId = Number(phases[0].id)
      }

      phases = phases.reverse()
      const counts = []
      phases.forEach((phase) => {
        counts.push(phase.phase)
        const index = counts.filter(x => x === phase.phase).length
        phase.name = this.$t('projects.stages.' + phase.phase) + ' ' + (index === 1 ? '' : index)
      })
      phases = phases.reverse()
      this.phases = phases
      var phase = this.phases.filter((x) => { return x.id === Number(this.projectPhaseId) })[0]
      // history.pushState({}, null, '/projects/' + this.projectCode + '/phases/' + Number(this.projectPhaseId) + '/' + this.tab)
      this.selectedPhase = phase
    },
    displayPhaseStatus () {
      if ((this.selectedPhase.status === this.phaseStatus.VERIFICATIONSEND) && !this.selectedPhase.forms.some(form => form.status === this.formStatus.LOCKED)) {
        return this.$t('projects.phaseStatuses.1')
      }
      if (typeof this.selectedPhase.statuses !== 'undefined' && this.selectedPhase.statuses !== null) {
        if (
          this.selectedPhase.statuses[0].status === this.phaseStatus.ENTRY &&
          this.selectedPhase.statuses[0].previousStatus === this.phaseStatus.WAITINGAPPROVAL
        ) {
          return this.$t('projects.phaseStatuses.99')
        }
      }

      return this.project && this.project.phaseStatus && this.selectedPhase ? this.$t('projects.phaseStatuses.' + this.selectedPhase.status) : ''
    },
    openActivitiesTab () {
      this.tab = 'activities'
      this.tabChanged(this.tab)
    },
    openRationalizationProposalDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.THIRD
      this.dialog = true
    },
    openIdeaDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.THIRD
      this.dialog = true
    },
    openCorrectionDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.THIRD
      this.dialog = true
    },
    openApproveImportant () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openUpdateImportantDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.SECOND
      this.dialog = true
    },
    openIdeaCommissionDecisionDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = true
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.showDateControl = true
      this.formActionText = this.$t('projects.commissionDecisionModalText')
      this.dateControlText = this.$t('form.commissionDecisionDateControlText')
      this.status.comment = ''
      this.status.date = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openProjectIdentificationCommissionDecisionDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = true
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.showDateControl = true
      this.formActionText = this.$t('projects.commissionDecisionModalText')
      this.dateControlText = this.$t('form.commissionDecisionDateControlText')
      this.status.comment = ''
      this.status.date = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openPreparednessCommissionDecisionDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = true
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.showDateControl = true
      this.formActionText = this.$t('projects.commissionDecisionModalText')
      this.dateControlText = this.$t('form.commissionDecisionDateControlText')
      this.status.comment = ''
      this.status.date = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openCorrectionCommissionDecisionDialog () {
      this.setDefaultActionsText()
      this.firstActionText = this.$t('form.correctionApproved')
      this.secondActionText = this.$t('form.correctionAmendment')
      this.thirdActionText = this.$t('form.postponed')
      this.fourthActionText = this.$t('form.stopped')
      this.showActionPromptOptions = true
      this.showThirdActionOption = true
      this.showFourthActionOption = true
      this.showFifthActionOption = false
      this.showDateControl = true
      this.showPostponedDateControl = true
      this.formActionText = this.$t('projects.commissionDecisionModalText')
      this.dateControlText = this.$t('form.commissionDecisionDateControlText')
      this.datePostponedControlText = this.$t('form.postponedDateControlText')
      this.status.comment = ''
      this.status.date = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openProjectIdentificationDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.THIRD
      this.dialog = true
    },
    openPreparednessDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.THIRD
      this.dialog = true
    },
    // openVerificationSendDialog () {
    //   this.setDefaultActionsText()
    //   this.showActionPromptOptions = false
    //   this.showThirdActionOption = false
    //   this.showFourthActionOption = false
    //   this.showFifthActionOption = false
    //   this.status.comment = ''
    //   this.status.action = this.projectAction.FIRST
    //   this.dialog = true
    // },
    // openMinisterApprovalDialog () {
    //   this.setDefaultActionsText()
    //   this.showActionPromptOptions = false
    //   this.showThirdActionOption = false
    //   this.showFourthActionOption = false
    //   this.showFifthActionOption = false
    //   this.status.comment = ''
    //   this.status.action = this.projectAction.FIRST
    //   this.dialog = true
    // },
    openMinisterApprovalSendDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openMinisterApprovalDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = (this.isPreImplementationPhaseInEntryStatus || (this.isLastFormInPhase && this.isReportingPhaseInEntryStatus)) || !this.phaseStatusesWithoutPrompt.includes(this.project.phaseStatus)
      this.status.comment = ''
      this.showThirdActionOption = false
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openMeiApprovalCommentSendDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openMeiApprovalCommentDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openCommissionDecisionDialog () {
      if (this.project.phase === this.projectPhases.RATIONALIZATION) {
        this.firstActionText = this.$t('form.correction')
        this.secondActionText = this.$t('form.postponed')
        this.formActionText = this.$t('projects.invokeRationalizationActionPrompt')
        this.showThirdActionOption = true
        this.showFourthActionOption = false
        this.showFifthActionOption = false
      } else {
        this.setDefaultActionsText()
        this.formActionText = this.$t('projects.invokeRationalizationProposalActionPrompt')
        this.showThirdActionOption = false
        this.showFourthActionOption = false
        this.showFifthActionOption = false
      }
      this.showActionPromptOptions = true
      this.status.comment = ''
      this.status.action = this.projectAction.FIRST
      this.dialog = true
    },
    openCancelPreImplementationDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = true
      this.showFourthActionOption = false
      this.showFifthActionOption = false
      this.status.comment = ''
      this.status.action = this.projectAction.THIRD
      this.dialog = true
    },
    openPlanCorrectionDialog () {
      this.setDefaultActionsText()
      this.showActionPromptOptions = false
      this.showThirdActionOption = false
      this.showFourthActionOption = false
      this.showFifthActionOption = true
      this.status.comment = ''
      this.status.action = this.projectAction.FIFTH
      this.dialog = true
    },
    setDefaultActionsText () {
      this.firstActionText = this.$t('form.yes')
      this.secondActionText = this.$t('form.no')
      this.thirdActionText = this.$t('form.stopped')
      this.fourthActionText = this.$t('form.addNewQaurter')
      this.formActionText = this.$t('projects.invokeActionPrompt')
      this.fifthActionText = this.$t('form.correction')
      this.dateControlText = this.$t('form.date')
      if (this.isPreImplementationPhaseInEntryStatus || (this.isLastFormInPhase && this.isReportingPhaseInEntryStatus)) {
        this.firstActionText = this.$t('form.approvePhase')
        this.secondActionText = this.$t('form.approveQaurter')
      } else {
        this.firstActionText = this.$t('form.yes')
        this.secondActionText = this.$t('form.no')
      }
    },
    tabChanged (tab) {
      // history.pushState({}, null, '/projects/' + this.projectCode + '/phases/' + Number(this.projectPhaseId) + `${'/' + tab}`)
      EventBus.$emit('reload-crumbs')
      EventBus.$emit('subTab', tab)
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
<style lang="scss">
  .admin-action {
    background-color: beige;
  }
</style>
